const items = [
  { icon: 'ri-star-fill', text: '5-Star Rated Service' },
  { icon: 'ri-shield-check-fill', text: 'Licensed & Insured Chauffeurs' },
  { icon: 'ri-time-fill', text: 'On-Time Guarantee' },
  { icon: 'ri-plane-fill', text: 'Airport & Corporate Specialists' },
];

export default function SiteTrustBar() {
  return (
    <section className="bg-gold py-4">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
          {items.map((item) => (
            <div key={item.text} className="flex items-center justify-center gap-2.5">
              <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                <i className={`${item.icon} text-black text-sm`}></i>
              </div>
              <span className="text-black font-bold text-xs tracking-widest uppercase text-center whitespace-nowrap">
                {item.text}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
